<template>
    <div id="data-list-list-view" class="data-list-container">
        <user-details :isSidebarActive="showSidebar"
                      :data="sidebarData"
                      :editEl="editEl"
                      :contracts="contracts"
                      :customerUser="customerUser"
                      @closeSidebar="toggleSidebar"/>
        <vs-table
                ref="table"
                v-model="selected"
                pagination
                :max-items="itemsPerPage"
                search
                :data="users"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <vs-button type="border" icon-pack="feather" icon="icon-plus" @click="addNewData">Ajouter un utilisateur</vs-button>
                </div>
            </div>
            <template slot="thead">
                <vs-th sort-key="name">Nom & Prénoms</vs-th>
                <vs-th sort-key="email">Email</vs-th>
                <vs-th sort-key="phone">Téléphone</vs-th>
                <vs-th sort-key="created_at">Inscrit le</vs-th>
                <vs-th sort-key="isActif">Statut</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <span class="font-semibold">
                            {{ tr.name+ ' '+tr.first_name }}
                            <span v-if="tr.is_master" class="bg-primary font-normal ml-2 p-1 text-white text-xs" style="border-radius: 40px">Master</span>
                        </span>
                    </vs-td>
                    <vs-td><span>{{ tr.email }}</span></vs-td>
                    <vs-td><span>{{ tr.phone }}</span></vs-td>
                    <vs-td><span>{{ tr.created_at }}</span></vs-td>
                    <vs-td>
                        <vs-chip :color="tr.status ? 'success' : 'danger'">{{ tr.status  ? 'Actif' : 'Suspendu' }}</vs-chip>
                    </vs-td>
                    <vs-td>
                        <div class="flex">
                            <vx-tooltip text="Modifier">
                                <feather-icon @click="editUser(tr)"
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2 cursor-pointer"
                                />
                            </vx-tooltip>
                            <vx-tooltip :text="tr.status ? 'Suspendre' : 'Activer'">
                                <feather-icon @click="suspendOrActive(tr.id, tr.status ? 0 : 1, tr)"
                                        :icon="tr.status ? 'LockIcon' : 'UnlockIcon'"
                                        svgClasses="w-5 h-5 stroke-current"
                                        class="mr-2 cursor-pointer"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Supprimer">
                                <feather-icon @click="deleteUser(tr)"
                                        icon="TrashIcon"
                                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                        class="mr-2 cursor-pointer"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
    import UserDetails from "./UserDetails";
    export default {
        components: {UserDetails},
        props:{
          users: {
            type: Array
          },
          customerUser:{
            type: Function
          },
        },
        data() {
            return {
                itemsPerPage: 8,
                isMounted: false,
                selected: [],
                showSidebar: false,
                sidebarData: {},
              editEl: false,
              contracts: []
            }
        },
        computed: {
        },
        mounted() {
            this.isMounted = true;
        },
        methods: {
          suspendOrActive(id, state, tr){
            if (state === 0){
              if (confirm('Voulez vous suspendre l\'utilisateur ?')){
                this.$vs.loading()
                this.$http.post('/users/suspend',
                  {id: id, state: state, customer: tr.customer_id, profile: tr.profile_id}
                ).then(() => {
                  this.$vs.loading.close()
                  this.customerUser()
                }).catch((error) => {
                  console.log(error)
                  this.$vs.loading.close()
                })
              }
            }else {
              if (confirm('Voulez vous activer l\'utilisateur ?')){
                this.$vs.loading()
                this.$http.post('/users/suspend',
                  {id: id, state: state, customer: tr.customer_id, profile: tr.profile_id}
                ).then((re) => {
                  if (!re.data.status){
                    window.GETCCMT.error({ message: "Cette opération ne peut être effectué car le compte masteur est suspendu" });
                  }else this.customerUser()
                  this.$vs.loading.close()
                }).catch((error) => {
                  console.log(error)
                  this.$vs.loading.close()
                })
              }
            }
          },
          customerContract(){
            this.$vs.loading()
            this.$http.get('/customers/contracts/'+this.$route.params.id).then((response) =>{
              this.contracts = response.data
              this.$vs.loading.close()
            }).catch((error) => {
              this.$vs.loading.close()
            })
          },
          deleteUser(tr){
            if (confirm('Voulez vous supprimer l\'utilisateur ?')){
              this.$vs.loading()
              this.$http.post('/users/delete',
                {id: tr.id, customer: tr.customer_id, profile: tr.profile_id}
              ).then((re) => {
                if (!re.data.status){
                  window.GETCCMT.error({ message: "Une erreur est survenu lors de l'opération" });
                }else {
                  let index = this.users.indexOf(tr)
                  this.users.splice(index, 1)
                }
                this.$vs.loading.close()
              }).catch((error) => {
                console.log(error)
                this.$vs.loading.close()
              })
            }
          },
          editUser(item){
            this.sidebarData = { ...item }
            this.customerContract()
            this.toggleSidebar(true)
          },
            toggleSidebar(val = false) {
                this.showSidebar = val;
            },
            addNewData() {
                this.sidebarData = {};
                this.customerContract()
                this.toggleSidebar(true);
            },
            editData(data) {
                this.editEl = true;
                this.sidebarData(data);
                this.toggleSidebar(true);
            }
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {
            @media (max-width: 689px) {
                .vs-table--search {
                    margin-left: 0;
                    max-width: unset;
                    width: 100%;

                    .vs-table--search-input {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 461px) {
                .items-per-page-handler {
                    display: none;
                }
            }

            @media (max-width: 341px) {
                .data-list-btn-container {
                    width: 100%;

                    .dd-actions,
                    .btn-add-new {
                        width: 100%;
                        margin-right: 0 !important;
                    }
                }
            }

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                    td {
                        padding: 20px;
                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }
                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }
                    }
                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check {
                    padding: 0 15px !important;
                }
                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
